module.exports = __webpack_public_path__ + "img/happy-straight.71708361.jpg";